/* eslint-disable */

const careers = () => {
	// Future Steve, I'm sorry , this works, im not sure how or why in some places.

	const header = document.querySelector('.c-site-header');
	const careersBlock = document.getElementById('c-careers');
	const filterBlock = document.getElementById('c-careers--filters');
	const filterBlocks = document.querySelectorAll('.c-careers--filters__block');
	const allFilters = document.querySelectorAll('.c-careers--filters input');
	const filterToggles = document.querySelectorAll('.c-careers--filters-toggle');
	const filterClear = document.querySelectorAll('.c-careers--filters-clear');
	const locationList = document.querySelectorAll('.c-careers--filters-locations input');
	const locationStatus = document.querySelector('.c-careers--fitlers-status-locations');
	const locationBlocks = document.querySelector('.c-careers-location');
	const deparmentBlocks = document.querySelector('.c-careers-department');
	const departmentList = document.querySelectorAll('.c-careers--filters-departments input');
	const departmentStatus = document.querySelector('.c-careers--filters-status-departments');
	const noJobsMessage = document.querySelector('.c-careers--no-jobs');
	const baseString = '.c-careers--filters';
	let baseUrl = "/en/careers/";

	const init = () => {
		if (allFilters.length > 0) {
			allFilters.forEach((element) => {
				element.addEventListener('change', function(e){  e.preventDefault(); handleSelect(element);});
			});
		}

		window.addEventListener('click', function(event) {
			var isClickInsideElement = filterBlock.contains(event.target);
			if (!isClickInsideElement){
				hideFilters();
			}
		});


		if (filterToggles.length > 0) {
			filterToggles.forEach((element) => {
				element.addEventListener('click', function(e){  e.preventDefault(); toggleFilters(element);});
			});
		}

		if (filterClear.length > 0) {
			filterClear.forEach((element) => {
				element.addEventListener('click', function(e){  e.preventDefault(); clearCheckboxes(element);});
			});
		}

		// Pre filter the results
		if(filterBlock) {
			const prefilter = filterBlock.getAttribute('data-prefilter');
			if(prefilter == "true") {
				applyFilters(false);
			}

			baseUrl = filterBlock.getAttribute('data-base-url');
		}
	};

	const countCheckboxes = (filterType) => {
		const filterList = document.querySelectorAll(baseString + '-' + filterType + ' input');
		let counter = 0;
		let categories = '';
		if (filterList.length > 0) {
			filterList.forEach((item) => {
				if (item.checked) {
					if(counter > 0) {
						categories += ', ';
					}
					categories += item.getAttribute('name');
					counter++;
				}
			});

			const statusMessage = counter + ' selected';
			if(counter < 1) {
				showAllItems(filterType);
			}

			if(counter == 1) {
				setCounterMessage(filterType, counter, categories);
			}else{
				setCounterMessage(filterType, counter);
			}


			setStatusMessage(filterType, statusMessage);
			setMiniStatusMessage(filterType, categories);
		}
	};

	const setCounterMessage = (statusAreaName, count, item) => {
		const statusArea = document.querySelector(baseString + '-count-' + statusAreaName);
		const message = "(" + count + ")";
		if (statusArea) {
			if(count > 0) {
				if(count == 1){
					statusArea.innerHTML = item;
				}else{
					if(statusAreaName == "locations"){
						statusArea.innerHTML = "Locations " + message;
					}else{
						statusArea.innerHTML = "Departments " + message;
					}
				}
			} else {
				if(statusAreaName == "locations"){
					statusArea.innerHTML = "Select location";
				}else{
					statusArea.innerHTML = "Select department";
				}
			}
		}
	};

	const setStatusMessage = (statusAreaName, statusMessage) => {
		const statusArea = document.querySelector(baseString + '-status-' + statusAreaName);
		if (statusArea) {
			statusArea.innerHTML = statusMessage;
		}
	};

	const setMiniStatusMessage = (statusAreaName, statusMessage) => {
		const statusArea = document.querySelector(baseString + '-status-mini-' + statusAreaName);
		if (statusArea) {
			statusArea.innerHTML = statusMessage;
		}
	};

	// Clear checkboxes
	const clearCheckboxes = (item) => {
		const filterType = item.getAttribute('data-filter-clear');
		const filterList = document.querySelectorAll(baseString + '-' + filterType + ' input');

		if (filterList.length > 0) {
			filterList.forEach((item) => {
				item.checked = false;
				item.parentNode.classList.remove("active");
			});
		}

		setStatusMessage(filterType, '0 selected');
		setMiniStatusMessage(filterType, '');
		setCounterMessage(filterType, 0);
		applyFilters();
	};

	const toggleFilters = (item) => {
		const filterType = item.getAttribute('data-filter');
		if (item.classList.contains("active")) {
			hideFilters();
		} else {
			hideFilters();
			item.classList.add("active");

			const filterBlock = document.querySelector(baseString + '__block-' + filterType);
			if (filterBlock) {
				if(filterBlock.classList.contains("active")) {
					filterBlock.classList.remove("active");
				} else {
					filterBlock.classList.add("active");
				}
			}
		}
	};

	const hideFilters = () => {
		if (filterToggles.length > 0) {
			filterToggles.forEach((element) => {
				element.classList.remove("active");
			});
		}
		if (filterBlocks.length > 0) {
			filterBlocks.forEach((element) => {
				element.classList.remove("active");
			});
		}
	};

	const showAllItems = (filterType) => {
		const filterItems = document.querySelectorAll('.c-careers--' + filterType);
		if (filterItems.length > 0) {
			filterItems.forEach((element) => {
				element.classList.add("active");
			});
		}
	};

	const hideAllItems = () => {
		const filterItems = document.querySelectorAll('.c-careers--item' );
		if (filterItems.length > 0) {
			filterItems.forEach((element) => {
				element.classList.remove("active");
			});
		}
	};

	const handleSelect = (item) => {
		item.parentNode.classList.toggle("active");
		const filterType = item.getAttribute('data-filter-type');
		applyFilters();

		/* scoll to careers section top to prevent ending too far away from the section when
		a filter is applied, since it will hide some sections */
		window.scrollTo(0, careersBlock.offsetTop - header.offsetHeight);
	};

	const showNoJobsMessage = () => {
		noJobsMessage.classList.add("active");
	};

	const hideNoJobsMessage = () => {
		noJobsMessage.classList.remove("active");
	};

	const applyFilters = (updateUrl = true) => {
		let locationsCounter = 0;
		let departmentsCounter = 0;

		const selectedFilters = [];;

		if (allFilters.length > 0) {
			hideAllItems();
			allFilters.forEach((item) => {
				if (item.checked) {
					const filterType = item.getAttribute('data-filter-type');
					const filterValue = item.getAttribute('value');
					const filterAttribute = "div[data-" + filterType + "='" + filterValue + "']";

					// console.log(filterType + " = " + filterValue);
					selectedFilters.push(filterValue);

					if (filterType == "locations"){
						locationsCounter++;
					}else{
						departmentsCounter++;
					}

					const filterItems = document.querySelectorAll(filterAttribute);
					if (filterItems.length > 0) {
						filterItems.forEach((filteredItem) => {
							filteredItem.classList.add('active');
						});
					}
				}
			});
		}

		if(updateUrl){
			// apply the URL updates
			if (baseUrl != ''){
				var urlTag = '';
				if (selectedFilters.length) {
					selectedFilters.forEach((tag) => {
						var cleanTag = tag.replace(/\s+/g, '-').toLowerCase();
						// Add a trailing slash if we have a tag
						if (cleanTag !== ''){
							urlTag = urlTag + cleanTag + "/";
						}
					});
				}

				// Add the selected filter to the URL
				history.pushState(null, null, baseUrl + urlTag);
			}
		}

		countCheckboxes("locations");
		countCheckboxes("departments");
		checkForNoResults();
	};

	const checkForNoResults = () => {
		const allLocations = document.querySelectorAll('.c-careers--locations.active');
		hideNoJobsMessage();
		let noJobs = true;
		if (allLocations.length > 0) {
			allLocations.forEach((element) => {
				const activeDepts = element.querySelectorAll('.c-careers--departments.active');
				if(activeDepts.length > 0) {
					noJobs = false;
				}else{
					element.classList.remove('active');
				}
			});
		}
		if(noJobs){
			showNoJobsMessage();
		}
	};


    if (filterBlock) {
        init();
    }
};

export default careers;
/* eslint-enable */
